<script>
import { Doughnut } from "vue-chartjs/legacy";

import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    CategoryScale,
  } from "chart.js";
  
  ChartJS.register(
    Title,
    Tooltip,
    Legend,
    ArcElement,
    CategoryScale,
  );

export default {
    extends: Doughnut,
    props: {
        chartId: {
            type: String,
            default: 'doughnut-chart-base'
        },
        chartData: {
            type: Object,
            default: () => ({})
        },
        chartOptions: {
            type: Object,
            default: () => ({
                responsive: true,
                maintainAspectRatio: false
            })
        }
    },
    mounted () {
        this.renderChart(this.chartData, this.chartOptions) // maybe typo?
    },
    methods: {
        resize() {
            this.$data._chart.resize()
        }
    },
    watch: {
        chartData () {
            this.$data._chart.update()
        }
    }
}
</script>